enum ToolBarButton {
  BOLD = 'BOLD',
  ITALIC = 'ITALIC',
  STRIKETHROUGH = 'STRIKETHROUGH',
  UNDERLINE = 'UNDERLINE',
  HIGHLIGHT = 'HIGHLIGHT',
  SUPERSCRIPT = 'SUPERSCRIPT',
  SUBSCRIPT = 'SUBSCRIPT',
  CODE = 'CODE',
  BLOCKQUOTE = 'blockQuote',
  UL = 'unordered-list-item',
  OL = 'ordered-list-item',
  CODEBLOCK = 'CODEBLOCK',
  UPPERCASE = 'UPPERCASE',
  LOWERCASE = 'LOWERCASE',
  LEFTALIGN = 'leftAlign',
  LINK = 'LINK',
  CENTERALIGN = 'centerAlign',
  RIGHTALIGN = 'rightAlign',
}
enum AdditionBtnStyle {
  HTMLCODE = 'select value parse',
  Link = 'link',
  Table = 'table',
  Undo = 'undo',
  Redo = 'redo',
  left = 'left',
  center = 'center',
  right = 'right',
  Image = 'image',
  Listul = 'list-ul',
  Listol = 'list-ol',
  // Emoji = 'emoji',
}
export { ToolBarButton, AdditionBtnStyle };
